<template>
  <v-app>
    <Toolbar/>
    <v-main>
      <v-container fluid>
        <v-card>
          <v-container class="text-center pt-5 mt-5">
            <p class="display-4">401</p>
            <p class="headline">No autorizado</p>
          </v-container>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// eslint-disable-next-line import/extensions
// import Profile from '../../plugins/profile';
// eslint-disable-next-line import/extensions
import Toolbar from '../../components/Toolbar';

export default {
  name: 'Error401',
  components: {
    Toolbar,
  },
};

</script>
